<!--
 * @Author: SongYijie
 * @Date: 2020-04-02 16:12:38
 * @LastEditors: SongYijie
-->
<template>
  <div class="image-preview" v-if="imgUrlOrigin">
    <span v-if="type === 'text'" @click="handlePreview">{{alt}}</span>
    <img v-else :src="imgUrlOrigin" :alt="alt" @click="handlePreview" />
    <transition name="fade">
      <div v-if="isPreview" class="mask" @click="cancelPreview">
        <img :src="imgUrlOrigin" :alt="alt" class="big-image" />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["imgUrl", "alt", 'type'],
  components: {},
  data() {
    return {
      isPreview: false
    };
  },
  computed: {
    imgUrlOrigin: function () {
      if (!this.imgUrl) {
        return ''
      }
      if (this.imgUrl.indexOf('/watermark_text') === -1 && this.imgUrl.indexOf('/original') === -1 && this.imgUrl.indexOf('http') !== -1) {
        return this.imgUrl + '/original';
      }
      return this.imgUrl;
    }
  },
  watch: {},
  mounted() {
  },
  methods: {
    handlePreview() {
      this.isPreview = true;
    },
    cancelPreview() {
      this.isPreview = false;
    }
  }
};
</script>
<style lang='less' scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
img {
  object-fit: cover;
}
.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.85);
  z-index: 3000;
}
.big-image {
  width: 100%;
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>